// An order's status — Estimate, Repair Order, Invoice, Archived — as the
// board, its list and a customer's order history show it. The board answers
// each card's _order_status_type (routes/admin/orderBoard.js STATUS_TYPE): the
// order's own status, or for an older one ('open'…) the type of the column it
// sits in.
import { familyByKey } from '../../utils/semanticColors';

export const STATUS_LABELS = { estimate: 'Estimate', repair_order: 'Repair Order', invoice: 'Invoice', archive: 'Archived' };
export const STATUS_PREFIX = { estimate: 'EST', repair_order: 'RO', invoice: 'INV', archive: 'ARC' };

// A column or tag without a color of its own: the semantic gray.
export const UNCOLORED = familyByKey('gray').vivid;

const has = (map, key) => Object.prototype.hasOwnProperty.call(map, key);

/** The status as one of the four ('archived', from older data, is Archive), else null. */
export const ownStatus = (status) => {
  if (status === 'archived') return 'archive';
  return typeof status === 'string' && has(STATUS_LABELS, status) ? status : null;
};

/** What a card's badge goes by: the order's own status, else the board's answer, else Estimate. */
export const statusTypeOf = (order) => ownStatus(order?.status) || ownStatus(order?._order_status_type) || 'estimate';

/** "Repair Order" — or an older status written out ("In progress"), or a dash. */
export function statusLabel(status) {
  const own = ownStatus(status);
  if (own) return STATUS_LABELS[own];
  const words = String(status || '').replace(/_/g, ' ').trim();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : '—';
}
